// extracted by mini-css-extract-plugin
export default {"container":"NxBreadcrumb__container--XfQHmujMusINEDdPpkWA","item":"NxBreadcrumb__item--xDNFVyao_sK7_yDvkrdw"};